"use client";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

import { getFormatMedia } from "~/theme/utils";

import { LATEST_ARTICLES_CAROUSEL_CLASSES } from "./constants";

export const LatestArticlesCarouselContainer = styled(Box)(({ theme }) => {
  const formatMedia = getFormatMedia(theme);
  return {
    marginBottom: theme.spacing(11),
    [`& .${LATEST_ARTICLES_CAROUSEL_CLASSES.header}`]: {
      position: "relative",
      zIndex: 2,
      display: "flex",
      flexDirection: "column",
    },
    [`& .${LATEST_ARTICLES_CAROUSEL_CLASSES.subtitle}`]: {
      order: -1,
      paddingBottom: theme.spacing(1),
      [formatMedia.BREAKPOINT_DESKTOP]: {
        paddingBottom: theme.spacing(2),
      },
    },
    [`& .${LATEST_ARTICLES_CAROUSEL_CLASSES.title}`]: {
      ...theme.typography.h4,
      textTransform: "inherit",
      paddingBottom: theme.spacing(1),
      [formatMedia.BREAKPOINT_TABLET]: {
        paddingBottom: theme.spacing(2),
        ...theme.typography.h3,
        textTransform: "inherit",
      },
      [formatMedia.BREAKPOINT_DESKTOP]: {
        paddingBottom: theme.spacing(2.5),
        ...theme.typography.h2,
        textTransform: "inherit",
        overflowWrap: "normal",
      },
    },
    [`& .${LATEST_ARTICLES_CAROUSEL_CLASSES.ctaLink}`]: {
      paddingBottom: theme.spacing(3.5),
    },
  };
});
